'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressController = function () {
  function AddressController($scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AddressController);
    if (this.firstLineReq) {
      this.configureForm();

      $scope.$on('parentFormConfigured', this.configureForm.bind(this));
    }
  }

  (0, _createClass3.default)(AddressController, [{
    key: 'configureForm',
    value: function configureForm() {
      var ctrl = this;

      if (this.firstLineReq) {
        ctrl.formValidationService.addField({
          fieldName: 'line1',
          displayName: 'Address Line 1',
          model: ctrl.container,
          required: true,
          stringLength: {
            min: 5,
            max: 100
          }
        });
      }
    }
  }]);
  return AddressController;
}();

exports.default = AddressController;


// WEBPACK FOOTER //
// ./client/app/components/common/address/address.controller.js